const DiscountCircle = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M9.99996 18.8334C14.6023 18.8334 18.3333 15.1025 18.3333 10.5001C18.3333 5.89771 14.6023 2.16675 9.99996 2.16675C5.39759 2.16675 1.66663 5.89771 1.66663 10.5001C1.66663 15.1025 5.39759 18.8334 9.99996 18.8334Z"
      fill="currentColor"
    />
    <path
      d="M12.5 13.8334C12.0333 13.8334 11.6583 13.4584 11.6583 13.0001C11.6583 12.5417 12.0333 12.1667 12.4917 12.1667C12.95 12.1667 13.325 12.5417 13.325 13.0001C13.325 13.4584 12.9583 13.8334 12.5 13.8334Z"
      fill="currentColor"
    />
    <path
      d="M7.5083 8.83341C7.04163 8.83341 6.66663 8.45841 6.66663 8.00008C6.66663 7.54175 7.04163 7.16675 7.49996 7.16675C7.95829 7.16675 8.33329 7.54175 8.33329 8.00008C8.33329 8.45841 7.96663 8.83341 7.5083 8.83341Z"
      fill="currentColor"
    />
    <path
      d="M7.50002 13.6249C7.34168 13.6249 7.18333 13.5666 7.05833 13.4416C6.81666 13.1999 6.81666 12.7999 7.05833 12.5582L12.0583 7.5582C12.3 7.31654 12.7 7.31654 12.9417 7.5582C13.1834 7.79987 13.1834 8.19992 12.9417 8.44159L7.94171 13.4416C7.81671 13.5666 7.65835 13.6249 7.50002 13.6249Z"
      fill="currentColor"
    />
  </svg>
);

export default DiscountCircle;
